import { Box, Grid, Paper, Typography } from '@mui/material'
import React from 'react'
import { AvatarPageTitle } from './AvatarPageTitle'

interface PageBannerProps {
  title: string,
  subTitle: string,
  icon: React.ReactNode
  secondaryComponent?: React.ReactNode
}

const PageBanner: React.FC<PageBannerProps> = ({ icon, title, subTitle, secondaryComponent }) => {
  return (
    <Paper
      elevation={3}
      style={{
        borderRadius: 0,
        padding: 15,
        width: '100%',
        borderBottom: '2px solid #663399'
      }}
    >
      <Grid container justifyContent={'center'} alignItems={'center'}>
        <Grid item xs={secondaryComponent == null ? 12 : 8}>
          <Box display="flex" alignItems="center">
            <AvatarPageTitle variant="rounded">
              {icon}
            </AvatarPageTitle>
            <Box>
              <Typography variant="h3" color={'#663399'} component="h3" gutterBottom>
                {title}
              </Typography>
              <Typography variant="subtitle2" color={'GrayText'}>
                {subTitle}
              </Typography>
            </Box>
          </Box>
        </Grid>
        {secondaryComponent &&
          <Grid item xs={4}>
            {secondaryComponent}
          </Grid>
        }
      </Grid>
    </Paper>
  )
}

export default PageBanner
